const App = () => null;

export default App;
